import { setAngularLanguage } from 'app/react-bridge/language-bridge';

// Adaptador fino sobre a ponte Angular (app/react-bridge/language-bridge), no
// mesmo padrão de auth-delegation.ts: o React não conhece o Angular, só a
// fronteira do seam.

/** Delega a troca de idioma para o Angular montado (AppModule completo e/ou folha), após a persistência do locale. */
export function delegateLeafLanguage(id: string): void {
  setAngularLanguage(id);
}
